import LoginScreen from './LoginScreen';
import Onboarding from './Onboarding';
import { useRef, useState } from 'react';

const Landing = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [userId, setUserId] = useState<number | null>(null);
  const [activeOnboardingStep, setActiveOnboardingStep] = useState<
    number | undefined
  >();

  const handleOnboardingStart = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.clientWidth,
        behavior: 'smooth',
      });
    }
  };

  const handleOnboardingCancel = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0 });
    }
  };

  const handleOnboardingInProgress = (
    userId: number,
    onboardingStep: number,
  ) => {
    setUserId(userId);
    handleOnboardingStart();
    setActiveOnboardingStep(onboardingStep);
  };

  return (
    <div
      ref={scrollRef}
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        overflowX: 'hidden',
      }}
    >
      <div style={{ flex: '0 0 100vw', display: 'flex', height: '100%' }}>
        <LoginScreen
          handleOnboardingStart={handleOnboardingStart}
          handleOnboardingInProgress={handleOnboardingInProgress}
        />
      </div>
      <div style={{ flex: '0 0 100vw', display: 'flex', height: '100%' }}>
        <Onboarding
          userId={userId}
          onCancel={handleOnboardingCancel}
          activeOnboardingStep={activeOnboardingStep}
        />
      </div>
    </div>
  );
};

export default Landing;
